export default "__VITE_ASSET__Cs6K3ONL__"